import React from "react";
import { useHistory } from "react-router";
import { Button, Menu, MenuItem } from "@mui/material";
import ChangePassword from "../../views/admin/ChangePassword";
import OpenDocuments from "../../helpers/openDocument";
import { CheckHasPermission, getFileMime } from "../../helpers/Common_functions";
import secureLocalStorage from "react-secure-storage";

const UserDropdown = ({ loggedUser }) => {
  // Dropdown state
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [openPass, setOpenPass] = React.useState(false);
  const history = useHistory();

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const userInfo = loggedUser?.Resource;



  return (
    <div>
      {/* Change Password Modal */}
      <ChangePassword open={openPass} setOpen={setOpenPass} />

      {/* Profile Button */}
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className="flex items-center space-x-3 p-2 bg-transparent hover:bg-gray-100 rounded-lg"
      >
        {/* Profile Image */}
        {!loggedUser?.isPartner &&         
        <div className="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full">
          {userInfo?.profile ? (
            <OpenDocuments
              planeImage
              imgClassName="w-full h-full rounded-full"
              document={userInfo.profile}
              mimeType={getFileMime(userInfo.profile)}
              name={userInfo.profile}
            />
          ) : (
            <img
              alt="Profile"
              className="w-full h-full"
              src={require("assets/img/team-2-800x800.png").default} // Ensure `.default`
            />
          )}
        </div>
   }

        {/* User Info */}
        <div className="hidden sm:block text-left">
          <p className="text-sm font-medium text-white">
            {userInfo?.names ?? loggedUser?.firstName+`${loggedUser?.lastName}`}
          </p>
          <p className="text-xs text-white lowercase">
            {userInfo?.email ?? loggedUser?.email}
          </p>
        </div>
      </Button>

      {/* Dropdown Menu */}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {
          !loggedUser?.isPartner &&         <MenuItem
          onClick={() => history.push(`/admin/profile/${userInfo?.id}`)}
        >
          My Profile
        </MenuItem>
        }
        <MenuItem onClick={() => setOpenPass(true)}>Change Password</MenuItem>
        {
          CheckHasPermission("menu.settings","read") && (
            <MenuItem
              onClick={() => {
                history.push(`/admin/seetings`);
                handleClose();
              }}
            >
              Settings
            </MenuItem>
          )
        }
        <MenuItem
          onClick={() => {
            secureLocalStorage.removeItem("token");
            window.location.replace("/");
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
};

export default UserDropdown;
